import React from "react";
import Component from "./component";
import WithApi from "../../../common/withApi";

export default props => {
  return (
    <WithApi {...props}>
      <Component {...props} />
    </WithApi>
  );
};
